
  import * as vercelRuntime$QQaN78tWlfGJBeHVde47E1KMQtK5yGgKQ_0C5nI8RLI from '/vercel/path1/node_modules/@nuxt/image/dist/runtime/providers/vercel'
  
  export const imageOptions = {
    ...{
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536,
    "xm": 440,
    "3xl": 1800,
    "4xl": 2000
  },
  "presets": {},
  "provider": "vercel",
  "domains": [
    "lifeboost-api.s3.us-east-2.amazonaws.com",
    "sale.lifeboostcoffee.com",
    "vercel.app",
    ".vercel.app",
    "cdn.builder.io"
  ],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
},
    providers: {
        ['vercel']: { provider: vercelRuntime$QQaN78tWlfGJBeHVde47E1KMQtK5yGgKQ_0C5nI8RLI, defaults: {} }
    }
  }
